import React, { useState } from "react";
import {
  Col,
  Modal,
  Row,
  Form,
} from "reactstrap";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { addAppleSMSFix, updateAppleSMSFix } from "../../../store/applesmsfix/actions";
import { useDispatch } from "react-redux";

const schema = yup.object().shape({
  email: yup.string().max(100).required(),
  password: yup.string().max(100).required(),
  phone: yup.string().max(50).nullable(),
  publicurl: yup.string().max(255).required(),
  birthday: yup.date().required(),
});

export default function AddNew({
  modal_center,
  tog_center,
  setmodal_center,
  data,
}) {
  const dispatch = useDispatch();

  const [files, setFiles] = useState(null);
  const [base64Image, setBase64Image] = useState("");

  const date = data.birthday ? new Date(data.birthday) : new Date();

  const formattedDate = `${date.getFullYear()}-${String(
    date.getMonth() + 1
  ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      email: data.email || "",
      password: data.password || "",
      phone: data.phone || "",
      publicurl: data.publicurl || "",
      birthday: formattedDate,
      note: data.note || "",
    },
  });

  const onSubmit = (formData) => {
    if (Object.keys(data).length !== 0) {
      dispatch(
        updateAppleSMSFix({ ...formData, id: data.id, image: base64Image })
      );
    } else {
      dispatch(addAppleSMSFix({ ...formData, image: base64Image }));
    }
    if (!Object.keys(errors).length) {
      setmodal_center(false);
    }
  };

  const imageUploadChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        setBase64Image(reader.result);
      };

      reader.readAsDataURL(file);
      setFiles(file);
    }
  };

  return (
    <Modal
      isOpen={modal_center}
      toggle={() => {
        tog_center();
      }}
      centered
    >
      <div className="modal-header">
        <h5
          className="modal-title mt-0"
          style={{ display: "flex", alignItems: "center" }}
        >
          <i class="ri-message-fill" style={{ paddingRight: 5 }}></i>{" "}
          {Object.keys(data).length !== 0 ? "Update" : "Add"} Apple SMS Fix
        </h5>
        <button
          type="button"
          onClick={() => {
            setmodal_center(false);
          }}
          className="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row className="mb-2">
            <Col md="12">
              <label for="file-input" className="filelabel">
                <input
                  id="file-input"
                  type="file"
                  className="fileinput"
                  onChange={imageUploadChange}
                />
                <img
                  className="logoimg"
                  id="img-preview"
                  src={
                    files
                      ? URL.createObjectURL(files)
                      : data.image
                      ? `https://api.grpiraq.net/public/storage/${data.image}`
                      : `https://api.grpiraq.net/public/storage/logo.png`
                  }
                />
                <p>Click the Image to Upload</p>
              </label>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md="6">
              <div className="field">
                <input
                  {...register("email")}
                  className={`form-control ${
                    errors.email ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="email"
                />
                <span class="label">Enter email</span>
              </div>
            </Col>
            <Col md="6">
              <div className="field">
                <input
                  {...register("password")}
                  className={`form-control ${
                    errors.password ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="text"
                />
                <span class="label">Password</span>
              </div>
            </Col>
          </Row>

          <Row className="mb-2">
            <Col md="6">
              <div className="field">
                <input
                  {...register("phone")}
                  className={`form-control ${
                    errors.phone ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="text"
                />
                <span class="label">Phone</span>
              </div>
            </Col>
          </Row>

          <hr />

          <Row className="mb-3">
            <Col md="6" className="mb-3">
              <div className="field">
                <input
                  className={`form-control ${
                    errors.publicurl ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="text"
                  {...register("publicurl")}
                />
                <span class="label">Url</span>
              </div>
            </Col>
            <Col md="6" className="mb-3">
              <div className="field">
                <input
                  className={`form-control ${
                    errors.birthday ? "is-invalid" : null
                  }`}
                  placeholder=""
                  type="date"
                  {...register("birthday")}
                />
                <span class="label">Birthday</span>
              </div>
            </Col>

            <Col md="12">
              <div className="field  mb-3">
                <textarea
                  className={`form-control ${
                    errors.note ? "is-invalid" : null
                  }`}
                  placeholder=""
                  {...register("note")}
                ></textarea>
                <span class="label">Note</span>
              </div>
            </Col>
          </Row>

          <div className="d-flex flex-wrap gap-2 justify-content-center">
            <button
              type="button"
              className="btn btn-lg btn-secondary"
              onClick={() => {
                setmodal_center(false);
              }}
            >
              Cancel
            </button>
            <button type="submit" className="btn btn-lg btn-primary">
              {Object.keys(data).length !== 0 ? "Update" : "Add New"}
            </button>
          </div>
        </Form>
      </div>
    </Modal>
  );
}
